import React from 'react'
import { Slider, TextField, withStyles } from '@material-ui/core'
import InputMask from 'react-input-mask'
import { GRAY_COLORS, PRIMARY_COLORS } from '../colors.constant'
import { makeStyles } from '@material-ui/core/styles'

const PercentSlider = props => {
  const useStyles = makeStyles(theme => ({
    root: {
      display: 'flex',
      justifyContent: 'center',
      padding: '0 8px '
    }
  }))

  const PercentSlider = withStyles({
    root: {
      color: '#3880ff',
      height: 8
    },
    thumb: {
      height: 24,
      width: 24,
      backgroundColor: '#fff',
      marginTop: -9,
      marginLeft: -15,
      marginRight: 15,
      border: '2px solid ' + PRIMARY_COLORS['600'],
      '&:focus, &:hover, &$active': {
        boxShadow:
          '0 3px 1px rgba(0,0,0,0.1),0 4px 8px rgba(0,0,0,0.3),0 0 0 1px rgba(0,0,0,0.02)'
        // Reset on touch devices, it doesn't add specificity
      }
    },
    active: {},
    valueLabel: {
      left: 'calc(-50% + 12px)',
      top: -22,
      '& *': {
        background: 'transparent',
        color: '#000'
      }
    },
    track: {
      height: 8,
      borderRadius: 5,
      backgroundColor: PRIMARY_COLORS['600']
    },
    rail: {
      height: 8,
      borderRadius: 5,
      opacity: 0.5,
      backgroundColor: GRAY_COLORS['200']
    }
  })(Slider)
  const classes = useStyles()
  return (
    <div className={classes.root}>
      <PercentSlider disabled={props.disabled} />
    </div>
  )
}

export default PercentSlider
